import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PhoneSelect } from "../../../../app/modules/Ticker/PhoneSelect";
import * as helpers from "../../../../app/util/helpers";
import { QuickUserToggler } from "../extras/QuiclUserToggler";
import { Settings } from "../extras/Settings";
import CustomSwitch from "../../../../app/modules/Settings/pages/Settings/Util/CustomSwitch";
import { actions } from "../../../../app/modules/Auth/_redux/authRedux";
import { useLocation } from "react-router-dom";
// import Joyride from 'react-joyride';

export function Topbar({ setPsuedoEl }) {

  const dispatch = useDispatch();

  const location = useLocation();

  const userRole = helpers.isAgent()? "Agent" : helpers.isSuperVisor()? "Supervisor" : helpers.isAdmin? "Admin" : "";

  useEffect(() => {
    if(helpers.isFeatureEnabledProfile('hide_iframe_redirection')) return;
    const initialSwitchState = { ...JSON.parse(localStorage.getItem("switch_old_state")), [location.pathname]: true };
    try {
      const switchState = JSON.parse(localStorage.getItem("switch_old_state"))[location.pathname];
      if (switchState == null || switchState == undefined) localStorage.setItem("switch_old_state", JSON.stringify(initialSwitchState));
    } catch (error) { localStorage.setItem("switch_old_state", JSON.stringify(initialSwitchState)); }
  }, [location.pathname, JSON.parse(localStorage.getItem("switch_old_state"))])

  const switchOldHandler = (key) => {
    const cloneOldSwitchState = { ...JSON.parse(localStorage.getItem('switch_old_state')) };
    cloneOldSwitchState[key] = !JSON.parse(localStorage.getItem('switch_old_state'))[key];
    dispatch(actions.setSwitchToOld({ switch_old_state: cloneOldSwitchState }));
  }

  const customOldSrModules = [
  '/callflow', '/smsflow', '/callgroups', '/integrations', 
  '/createcampaign', '/campaign', '/settings', '/history',
  '/settings', '/history', '/billstatement', '/invoices', '/payments', 
  '/billing_summary', '/reports', '/dashboard', '/insights', '/account_profile',
  '/live-interactions/queues-monitor', '/home', '/customer-management/customer'
  ];

  // const steps = [
  //   {
  //     target: '.toggle-old-sr',
  //     content: 'This is a toggle dedicated to switching in between Old SR experience and New SR experience.',
  //   }
  // ]

  // const [showJoyride, setShowJoyride] = useState(false);

  // useEffect(() => {
  //   const isLoggedIn = helpers.isLoggedIn();
  //   const joyrideFlag = localStorage.getItem('joyrideShown');
  //   if (isLoggedIn && !joyrideFlag) {
  //     setShowJoyride(true);
  //   }
  //   return () => {
  //     localStorage.removeItem('joyrideShown');
  //   };
  // }, []);

  return (
    <div className="topbar d-flex align-items-center">
      {!customOldSrModules.includes(location.pathname) && !helpers.isFeatureEnabledProfile('hide_iframe_redirection') &&
        <>
          {/* {showJoyride && (<Joyride 
          steps={steps} 
          run={showJoyride}
          // hideCloseButton={true} 
          callback={(props) => {
            if (props.status === 'finished') {
              localStorage.setItem('joyrideShown', 'true');
              setShowJoyride(false);
            }
          }}
          styles={{
            options: {
              // arrowColor: 'rgb(44, 54, 135)',
              // backgroundColor: 'rgb(44, 54, 135)',
              // beaconSize: 40,
              // primaryColor: '#000',
              // textColor: '#fff',
              // zIndex: 1000,
              // overlayColor: 'rgba(44, 54, 135, 0.4)',
              // width: 900,
            }
          }}
          />)} */}
          <div className="toggle-old-sr" style={{
            display: "flex",
            flexDirection: "row",
            alignItems: 'center',
            justifyContent: "center",
            padding: "0 10px",
          }}>
            <span className="mr-2" style={{
              fontSize: 'smaller',
              fontWeight: 600,
              color: "grey",
            }}>{'New UI'}</span>
            <CustomSwitch onClickHandler={() => switchOldHandler(location.pathname)} state={(JSON.parse(localStorage.getItem('switch_old_state')) && JSON.parse(localStorage.getItem('switch_old_state'))[location.pathname])} />
            <span className="ml-2" style={{
              fontSize: 'smaller',
              fontWeight: 600,
              color: "grey",
            }}>{'Old UI'}</span>
          </div>
        </>
      }
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          padding: "0 10px",
          fontWeight: 500,
          color: "#2c3687",
        }}
      >
        <div style={{ padding: "7px 10px", color: "#443490" }}>
          <span>{userRole}</span>
        </div>
      </div>
      {helpers.isFeatureEnabled("is_hook_api_enabled") &&
        !helpers.isAgent() && <Settings />}
      {helpers.isTickerModuleEnabled() && <PhoneSelect />}
      {<QuickUserToggler setPsuedoEl={setPsuedoEl}/>}
    </div>
  );
}
